import React from 'react';
import { FDStack } from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';

export const StepLayout = () => {
  return (
    <FDStack direction="column" spacing={2}>
      <MetaLayoutRemainingFields fullWidth noAccordion />
    </FDStack>
  );
};
